import { render, staticRenderFns } from "./IconAnimationProperty.vue?vue&type=template&id=4b6aca61&"
import script from "./IconAnimationProperty.vue?vue&type=script&lang=js&"
export * from "./IconAnimationProperty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports